<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        中心仓危险事件汇总
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExport"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.alarmStartRange">
            <el-date-picker
              v-model="slotForms.forms.alarmStartRange"
              type="datetimerange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.comparyIds">
            <el-select
              v-model="slotForms.forms.comparyIds"
              multiple
              collapse-tags
              clearable
              filterable
              placeholder="企业名称"
            >
              <el-option
                v-for="item in comparyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.storageIds">
            <e6Select
              :dataList="storageOptions"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              :disabledNoCheck="true"
              multiple
              ref="storageTreeSelect"
              :placeholder="'仓库名称'"
              @multipleSelect="handleSelStorage"
            ></e6Select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          label="仓库名称"
          min-width="180"
          fixed
          header-align="center"
          align="left"
          :show-overflow-tooltip="true"
          prop="storageName"
        ></el-table-column>
        <el-table-column
          label="所属企业"
          min-width="180"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="comparyName"
        ></el-table-column>
        <el-table-column
          label="危险事件总数"
          min-width="150"
          header-align="center"
          :show-overflow-tooltip="true"
          align="right"
          prop="eventNumAll"
        ></el-table-column>
        <el-table-column
          label="未戴口罩"
          min-width="120"
          header-align="center"
          :show-overflow-tooltip="true"
          align="right"
        >
          <template slot-scope="{ row }">
            <div v-if="row.eventNum1 == 0">{{ row.eventNum1 }}</div>
            <el-button v-else type="text" @click="goToDetail(row, 1)">{{
              row.eventNum1
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="未穿防护服"
          min-width="120"
          :show-overflow-tooltip="true"
          header-align="center"
          align="right"
        >
          <template slot-scope="{ row }">
            <div v-if="row.eventNum2 == 0">{{ row.eventNum2 }}</div>
            <el-button v-else type="text" @click="goToDetail(row, 2)">{{
              row.eventNum2
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
import {
  FetchDangerousCollectList,
  exportDangerousCollect,
  FetchStorageList
} from "@/api/report/dangerous";
import { FetchAllComparys } from "_private/api/systemSetting/userManage";
import { mapGetters, mapActions } from "vuex";
import { cloneDeep } from "lodash";
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
import { exportXlsx } from "@/utils/exportXlsx.js";
import moment from "moment";

export default {
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      formExtend: {
        forms: {
          alarmStartRange: [
            moment()
              .startOf("day")
              .format("YYYY-MM-DD HH:mm:ss"),
            moment()
              .endOf("day")
              .format("YYYY-MM-DD HH:mm:ss")
          ],
          storageIds: [], // 仓库名称
          comparyIds: []
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      comparyOptions: [],
      storageOptions: [],
      loading: "false",
      datePickerOptions: datePickerOptionsNotContainToday,
      //导出URL
      exportUrl: "/report/storage/info/exportStorageAlarmInfo?"
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"])
  },
  created() {
    // 查询列表数据
    this.FetchFindByPage(this.mergeObj());
    this.setSearchFormIsOpenAct();
    this.FetchComparyList();
    this.FetchStorageList();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 检验时间40天
    validataTime() {
      let start = moment(this.formExtend.forms.alarmStartRange[0]);
      let end = moment(this.formExtend.forms.alarmStartRange[1]);
      //判断时间间隔不能大于40天
      if (end.diff(start, "days") > 39) {
        this.$message.warning("开始时间与结束时间间隔不能大于40天！");
        return false;
      } else {
        return true;
      }
    },
    // 获取企业名称下拉
    FetchComparyList() {
      FetchAllComparys()
        .then(res => {
          if (res.result && res.result && Array.isArray(res.result)) {
            this.comparyOptions = res.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取仓库下拉
    FetchStorageList() {
      FetchStorageList()
        .then(response => {
          if (response.code == 1 && response.result) {
            this.storageOptions = response.result;
          } else {
            this.$message({
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 选择仓库
    handleSelStorage(val) {
      this.formExtend.forms.storageIds = [];
      val.forEach(v => {
        this.formExtend.forms.storageIds.push(Number(v.id));
      });
    },
    // 获取表格数据
    FetchFindByPage(response) {
      if (!response.alarmStartRange) {
        this.$message.warning("开始时间与结束时间不能为空！");
        return;
      }
      this.tableData = [];
      if (this.validataTime()) {
        this.loading = true;
        let params = cloneDeep(response);
        params.startTime = params.alarmStartRange[0];
        params.endTime = params.alarmStartRange[1];
        Reflect.deleteProperty(params, "alarmStartRange");
        FetchDangerousCollectList(params)
          .then(response => {
            if (
              response.result &&
              response.result.data &&
              Array.isArray(response.result.data)
            ) {
              this.tableData = response.result.data;
              this.total = response.result.totalRecords;
            }
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      }
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 导出excel 表格
    handleExport() {
      if (this.validataTime()) {
        let params = this.mergeObj();
        params.startTime = params.alarmStartRange[0];
        params.endTime = params.alarmStartRange[1];
        Reflect.deleteProperty(params, "alarmStartRange");
        this.exportData(params);
      }
    },
    // 导出页面数据接口请求
    async exportData(params) {
      try {
        exportDangerousCollect(params).then(res => {
          // 导出
          exportXlsx(res, `中心仓危险事件汇总.xls`);
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    //重置
    handleResetForm() {
      this.$refs["storageTreeSelect"].multipleRemoveAll();
    },
    //导出
    handleExportClick() {
      let param = "";
      if (
        this.formExtend.forms.alarmStartRange !== null &&
        this.formExtend.forms.alarmStartRange !== ""
      ) {
        param += "&alarmBeginTime=" + this.formExtend.forms.alarmStartRange[0];
        param += "&alarmFinishTime=" + this.formExtend.forms.alarmStartRange[1];
        param +=
          "&cameraInfo=" +
          (this.formExtend.forms.cameraInfo == undefined
            ? ""
            : this.formExtend.forms.cameraInfo);
        param +=
          "&storageIds=" +
          (this.formExtend.forms.storageIds == undefined
            ? []
            : this.formExtend.forms.storageIds);
        // param += "&userId=" + 1;
        document.location.href = this.exportUrl + param;
      } else {
        this.$message({
          showClose: true,
          message: "开始时间与结束时间不能为空！",
          type: "warning"
        });
      }
    },
    // 跳转明细
    goToDetail(row, type) {
      this.$router.push({
        path: "/dangerousDetail",
        query: {
          comparyId: row.comparyId,
          storageId: row.storageId,
          type: type,
          startTime: this.formExtend.forms.alarmStartRange[0],
          endTime: this.formExtend.forms.alarmStartRange[1]
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
/deep/ .el-tag {
  max-width: 85px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
